import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { APP_CONFIG } from '../../services/config/app-config.token';
import { AppConfig } from '../../services/config/config.model';

@Injectable({
    providedIn: 'root',
})
export class UnsubscribeService {
    private baseUrl: string;
    private httpClient = inject(HttpClient);
    private config: AppConfig = inject(APP_CONFIG);

    constructor() {
        // Normalize root (mirrors logic in HealthService):
        // '' or '/api' => '/api/v1'
        // host => host + '/api/v1'
        const root = (this.config.dsiMessagingServiceUrl || '').replace(/\/+$/, '');
        if (root === '' || root === '/api') {
            this.baseUrl = '/api/v1';
        } else {
            this.baseUrl = `${root}/api/v1`;
        }
    }

    public unsubscribe(guid: string): Observable<string> {
        const request = { EmailGuid: guid };
        const options = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
        };
        return this.httpClient.post<UnsubscribeResponse>(`${this.baseUrl}/Email/Unsubscribe`, request, options).pipe(
            map((response: UnsubscribeResponse) => {
                return response.Email;
            })
        );
    }
}

export interface UnsubscribeRequest {
    EmailGuid: string;
}

export interface UnsubscribeResponse {
    Email: string;
}
